/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { LoanAgreementPO } from '@/api/contract/types';
import { session } from '@/shared/utils/storage';
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type { LoanUsageOption } from '@/api/apply-product/types';

const ApplyProductStore = namespace('applyProduct');

const style = require('./index.module.scss');

@Component({ name: 'YHApplyConstract' })
export default class YHApplyConstract extends Vue {
  private loanContractForm: LoanAgreementPO = Object.create(null);

  @ApplyProductStore.State usage!: LoanUsageOption;

  private get funderCode() {
    return [
      'HANGYIN',
    ].indexOf(this.loanContractForm && this.loanContractForm.funderCode) >= 0;
  }

  private created() {
    this.loanContractForm = session.get('loanContractForm') as LoanAgreementPO;
  }

  private render() {
    const {
      funderName,
      contractNo,
      mobile,
      userAccount,
      userName,
      idCard,
      applyAmountChinese,
      applyAmount,
      yearInterestRate,
      repayDate,
      effectiveDate,
      bankName,
      applyPeriod,
    } = this.loanContractForm;
    return (
      <div class={style.YHApplyConstract}>
      <div class={style.content}>
        <p class={style.title}>
          <strong>{funderName}个人消费贷款合同</strong>
        </p>
        <p>（hyxf_halo ver.4.0；202306）</p>
        <p>合同详情</p>
        <p>合同编号：{contractNo}</p>
        <p>
          <strong>特别提醒：</strong>
          在您确认签署本合同(包括附件，下同)之前，请您务必充分阅读本合同所有条款，尤其是加粗部分。如您对本合同内容及页面提示信息有疑问，请您暂停后续操作，您可通过“臻有钱”（以下称：线上贷款服务平台）在线客服或线上贷款服务平台电话客服400-868-9966咨询，以便我们为您解释和说明。
        </p>
        <p>贷款人关注且重视未成年人权益的保障，<strong>您申请贷款时应年满十八周岁且非为在校大学生。</strong>若您未满十八周岁，应当立即取得监护人对您使用线上贷款服务平台服务的许可并在还款后关闭线上贷款服务平台服务，贷款人亦可即时终止对您的服务。若您为在校大学生，经发现后，您应在还款后关闭线上贷款服务平台服务，贷款人亦可即时终止对您的服务。</p>
        <p>您认可：一旦您通过点击或其他方式确认本协议，即表示您认可根据《中华人民共和国民法典》及相关法律法规、司法解释等，以数据电文形式订立本合同，愿意向：杭银消费金融股份有限公司(本合同中简称“贷款人”)申请消费贷(以下简称"本贷款")，并理解和接受线上贷款服务平台服务使用中的权利和义务；根据银行相关合同和本合同的约定，贷款人将以银行财产中的现金部分向借款人发放的消费贷款。本合同自贷款人确认后视为其与您就合同约定达成一致，本合同生效。您同意，即便在点击时本合同未显示贷款人信息，您也不因此否认本合同项下的债权债务关系或拒绝履行相关权利义务或以任何方式否认、撤销本合同。</p>
        <p>本合同由正文、附件以及不时发布的相关页面、账单、指引、说明和介绍(以下统称“规则文件”)等共同组成，并共同构成您与贷款人之间就本贷款的完整的协议。若规则文件与本合同约定不一致，应以规则文件为准。根据业务实际，规则文件可能会被适时修改，请您及时关注和了解。</p>
        <p>
          <strong>第一条 借款信息</strong>
        </p>
        <p>为了保护您的个人信息，本合同在向您展示时将隐藏您部分身份信息，您的身份信息详情以您用于签署本合同填写的个人申请信息为准。</p>
        <p>您的基本信息：</p>
        <p>借款人：{userName}</p>
        <p>证件号码：{idCard}</p>
        <p>证件类型：身份证</p>
        <p>贷款金额：{applyAmount}元(大写：{applyAmountChinese})</p>
        <p>贷款期数：{applyPeriod}期</p>
        <p>贷款初始年利率：{yearInterestRate}（本产品年化利率采用单利计算方法）</p>
        <p>贷款初始年利率=1年期LPR+ %= {yearInterestRate}</p>
        <p>借款用途: {this.usage.name}</p>
        <p>收款账户户名：{userName}</p>
        <p>银行账号：{userAccount}</p>
        <p>开户行：{bankName}</p>
        <p>还款方式：等额本息</p>
        <p>放款日：{effectiveDate}</p>
        <p>还款日：自贷款发放之日起每月{repayDate}（如遇节假日，不顺延)，本合同另有约定的除外</p>
        <p>合同签订地及履行地：债权人所在地</p>
        <p>合同生效日期：{effectiveDate}</p>
        <p><strong>第二条 借款人保证</strong></p>
        <p>1.您有足够的偿债能力，可以合理安排您的还款计划；</p>
        <p>2.您确实存在符合约定的贷款用途需求；</p>
        <p>3.为申请贷款，您愿意按贷款人的要求提交真实、准确、有效的个人信息、交易信息等；</p>
        <p>4.您愿意关注您的还款账户余额及状态，并按本合同相关约定及时归还全部应付款项；</p>
        <p>5.您已阅读并同意本合同及附件的条款约定。</p>
        <p><strong>第三条 贷款金额、发放、用途及查询</strong></p>
        <p>1.贷款人将把贷款资金发放至本合同第一条约定的银行账户(以下简称“收款账户”)，具体贷款金额以合同第一条约定为准。本合同项下的贷款发放日为贷款资金划付至收款账户的日期(本合同所涉时间如无特别说明，均为北京时间)。</p>
        <p>如因您提供的账户信息有误、账户状态不正常，或者因所提供账户的开户银行汇款转账系统延误、故障或者因人行跨行转账系统延误、故障等原因导致贷款人发放的贷款未能在约定的借款起始日当日支付至约定的收款账户的，贷款人不承担责任且有权从约定的借款起始日开始计息/费。若因上述原因导致贷款人放款失败的，您需重新申请放款。</p>
        <p>2.本合同项下的贷款仅用于消费及您所披露的借款用途，未经贷款人同意，您不能改变资金用途。</p>
        <p>3.为了更好地为您提供服务，我们将通过贷款平台等相关信息渠道提供贷款额度、支用金额、还款计划及还款明细等贷款信息的查询和展示服务。</p>
        <p><strong>第四条 贷款期限</strong></p>
        <p>除本合同另有约定外，您的贷款期限可参见本合同第一条，从贷款发放之日起计算，除贷款人同意外不可延长贷款期限。若您存在多笔贷款，则前述贷款的还款日将被统一成同一天，且由于还款日当天系统进行到期扣款操作的时点可能早于或晚于您的放款时点，故您在本合同项下的贷款期限可能缩短或延长，对此您予以认可。若发生本合同第九条约定的任一违约情形时，本合同项下已发放的部分或全部贷款可能会被贷款人宣布提前到期。</p>
        <p><strong>第五条 贷款利率、违约金计算方式和计息、结息、付息</strong></p>
        <p><strong>一、贷款利率与违约金计算方式</strong></p>
        <p><strong>(一)贷款利率</strong></p>
        <p>1.本合同项下贷款均采用年利率计算，本合同项下贷款年利率参考本合同签署日前一工作日全国银行间同业拆借中心最新1年期贷款市场报价利率(LPR)定价；</p>
        <p>2.本合同第一条所述的贷款利率为贷款原始利率；若您获得利息或利率折扣优惠，则根据优惠规则所确定的折后利率为本合同贷款实际利率。若您逾期归还贷款本金、利息或其他费用(如有)，贷款人有权取消该等优惠，以贷款初始利率计息；</p>
        <p>3.您使用优惠前请特别注意关于折扣优惠的所有页面文案及规则(以下简称“优惠规则”)。若您不予认可优惠规则，请勿使用相应的优惠。</p>
        <p><strong>(二)违约金计算方式</strong></p>
        <p>本合同项下贷款逾期的违约金在上述(一)项贷款日利率（日利率=年利率/360天）水平上加收50%；您未按本合同约定用途使用贷款（即挪用）的违约金在上述(一)项贷款日利率水平上加收100%。</p>
        <p><strong>二、计息、结息和付息</strong></p>
        <p>1.贷款利息自贷款发放日起(含发放日)计算，按日计息，按本合同还款约定进行结息、付息，利随本清；</p>
        <p>2.若您未能按期归还贷款本金(包括被宣布全部或部分提前到期的贷款本金)，则自逾期之日起您需按本合同约定的违约金标准支付违约金。对您未按时支付的利息，按逾期违约金计算标准计收复利；</p>
        <p>3.若您未按本合同约定用途使用贷款，则挪用部分贷款资金自您挪用之日起将按本合同约定的挪用贷款违约金计算标准计算违约金，贷款被挪用期间未按时支付的利息，按挪用贷款违约金计算标准计收复利。对于既逾期又未按本合同约定用途使用贷款的，择较重者计算，不予并处；</p>
        <p>4.贷款人向您收取的息费总和(如有)与融资本金的比例，折算为年化综合实际利率后上限将不超过监管规定的定价标准；若后续法律法规或监管规定变化的，我们将遵照最新规定执行。</p>
        <p><strong>第六条还款</strong></p>
        <p><strong>一、还款方式：</strong></p>
        <p>除本合同另有约定外，贷款的还款方式为下述方式其中之一，您适用的还款方式详见本合同第一条：</p>
        <p>1.按月等额本息还款(每月等额)：即按贷款人的要求，每月以固定金额偿还贷款本息，贷款到期日归还剩余本金和利息；</p>
        <p>2.按月等额本金还款：即按贷款人的要求，每月以固定金额偿还贷款本金，并偿付当月实际产生的利息，贷款到期日归还剩余贷款本金及利息；</p>
        <p><strong>二、还款日</strong></p>
<p>1.还款日请详见页面展示，请您知晓并同意，若您有多笔按月借款类贷款(借款期限按月计算)，则每笔此类贷款的还款日将被固定统一成同一天，您应根据该还款日按约定的还款方式还款。需要提醒您注意的是，在放款日为非还款日的情况下：</p>
<p>1)若贷款放款日距离贷款发放后的首个还款日不满15个自然日，则第一期还款顺延至贷款发放后第二个还款日归还，贷款期限相应延长至初始贷款期限届满日后的首个还款日；</p>
<p>2)若贷款放款日距离贷款发放后的首个还款日超过15个自然日(含)，则第一期还款应在贷款发放后首个还款日归还，贷款期限缩短至初始贷款期限届满日前一个还款日。</p>
<p>2.部分情况下，您的还款日为您贷款发放日所对应的自然日或由系统指定；</p>
<p>3.您在贷款人处按日借款类贷款(借款期限按天数计算)的还款日以实际贷款到期日为准。</p>
<p><strong>三、应还款额</strong></p>
<p>对于本合同项下的贷款本金和/或相应利息，您应按本合同约定的还款方式还款。您每个还款日的应还款额系通过对您的还款方式、贷款余额、利率及期限等综合计算得出。您可在贷款平台查询您每个还款日的应还款额，于还款日或之前自主选择支付宝账户、绑定的银行账户或余额宝等途径归还上述款项。</p>
<p><strong>四、到期还款</strong></p>
<p>1.主动还款：您可主动登录线上贷款服务平台服务页面，通过支付宝账户余额或您绑定的银行账户或余额宝或系统支持的其他还款来源按照贷款人认可的还款规则清偿相应的款项；</p>
<p>2.自动还款：除您主动还款外，您同意，在系统功能可实现的情况下，从还款日当天开始(具体扣款时点以系统实现为准)，贷款人将对您发起自动扣款。请在还款日前确保您用于还款的支付宝账户余额、支付宝账户或支付宝绑定的银行账户余额充足或余额宝拥有足够的份额；确保前述账户的功能未受限制且未超限额。</p>
<p>2.1除非与您另有约定，您同意贷款人可在每个还款日从您的支付宝账户、支付宝账户绑定的其他银行借记账户中以及通过余额宝或系统支持的其他还款来源等扣收您的欠款；</p>
<p>2.2您同意除非与您另有约定，若发生下述任一情形，贷款人将根据上述自动还款的扣款途径和规则对您的各类还款来源持续进行扣款操作，直至欠款清偿完毕：</p>
<p>2.2.1您的贷款被宣布提前到期；</p>
<p>2.2.2还款日后，您未能清偿应还款额。</p>
<p><strong>五、逾期还款</strong></p>
<p>若您的贷款逾期，除保持前述到期还款的途径和扣款方式外，贷款人将采取如下措施：</p>
<p>1.通知支付宝公司对您的所有支付宝账户及与之绑定的银行账户采取扣划应还款项或止付或停止支付、提现等其他限制措施；</p>
<p>2.若您在贷款人或贷款人关联公司处有应收或留存款项，则将自前述款项中扣收相应金额用以偿还您在本合同项下的欠款；</p>
<p>3.在没有与您另行约定的情况下，您不可撤销地同意及授权支付宝公司及其他贷款人的关联公司按照本合同的约定，根据贷款人的指示执行前述措施；</p>
<p>4.上述措施及自动扣款在您结清贷款前会持续实施，可能导致您的存款、应收、留存款项提前到期或者您的资产被提前赎回，再次提醒您切勿逾期还款。</p>
<p><strong>六、提前还款</strong></p>
<p>1.贷款期限届满前，在征得贷款人同意的前提下，您可主动提前归还全部或部分贷款本金及息费(如有)。贷款人届时可能会向您收取提前还款手续费，具体收费标准详见本合同第一条提前还款手续费；若第一条无提前还款手续费，则您提前还款无需支付相应费用。提前还款手续费不以贷款资产权利义务的转让而转让；</p>
<p>2.请您知晓，您所还的款项将按照先偿还截至提前还款日的费用(如有)，再偿还全部贷款截至提前还款日的全部利息，余额偿还提前归还的本金的顺序予以操作，贷款人可以根据贷款风险政策和您的信用状况变更前述还款清偿顺序，或变更还款方式(如调整每期偿还金额)等。</p>
<p><strong>七、还款约定</strong></p>
<p>1.上述自动还款的目的是为了方便您还款，避免您因工作、生活繁忙造成还款疏漏，同时也为了保护贷款人的合法权益。但请您知晓，其可能受系统、技术、网络、合作机构等各类因素的限制而导致扣款失败；同时您的支付宝账户、支付宝账户绑定的银行账户、余额宝或系统支持的其他还款来源可能会出现余额不足、份额不足、付款、转让、赎回功能或转账额度受到限制等情况，此等情况出现也将导致扣款失败。因此，请您密切注意还款提示及结果，若出现自动扣款失败，请及时主动还款，避免您因延误还款导致线上贷款服务平台逾期；</p>
<p>2.请您知晓，自动扣款时，系统对不同扣款途径将按先支付宝账户、后银行借记账户、再余额宝的顺序依次扣款，若您对支付宝收银台的支付顺序做了调整或设置，则扣款途径也会做相应的顺序调整，具体以实际扣款顺序为准；</p>
<p>3.请您知晓，贷款人从还款日当天开始对您发起自动扣款操作，并可能根据系统或运营安排以及业务发展需要对扣款时点、扣款指令进行调整；</p>
<p>4.线上贷款服务平台服务的实现有赖于各项指令的执行，贷款人可能将向线上贷款服务平台服务顾问及其他相关方发出各项指令，也可能从前述各方及您处接收各项指令。您同意，除非另有约定，所有指令及内容在指令方发出后均无法撤销及变更；</p>
<p>5.为了实现还款功能(包括主动还款和自动扣款)，除非与您另有约定，贷款人将自行或授权支付宝及贷款人其他扣还款服务合作方根据贷款人的指令(在其认为的线上贷款服务平台服务必要范围内)或您的还款指令(例如您主动还款时)进行资金划扣。若通过余额宝方式还款，您亦同意余额宝的基金销售机构将基于贷款人的指令于还款日将您持有的余额宝全部或部分快速赎回并支付给贷款人用于偿还您的欠款。您理解，当您支付宝绑定的银行账户用于还款时，该账户开户行将根据您已签署的快捷支付服务协议及支付宝的指令，从您的银行账户中划扣相应款项；</p>
<p>6.若您支付宝还款账户、绑定的银行账户、余额宝的其他代扣服务的扣款时间优先于贷款人扣款时间，您应当通过其他途径按时还款(如主动还款)，以免逾期。反之，若其他代扣服务的扣款时间晚于贷款人扣款，您同意不以此为由要求贷款人承担您的损失或返还扣款等；</p>
<p>7.您知晓您的还款将首先用于偿还应由您承担的各项费用(如因您违约被起诉而需承担的诉讼费、律师代理费、催收费用等)，剩余款项按照先还息后还本、利随本清的原则偿还。还款的清偿顺序可能被作出调整，遇到多笔需要归还的贷款时，贷款人可能会根据实际需要自行决定还款的先后顺序和金额；</p>
<p>8.您的还款时间以贷款人实际收到还款资金的时间为准，还款金额以贷款人实际收到的还款金额为准。</p>
<p><strong>第七条权利和义务</strong></p>
<p><strong>一、您的主要权利和义务</strong></p>
<p>1.您有权要求对您提供的相关信息予以保密，但法律法规另有规定或本合同另有约定的除外。您可至线上贷款服务平台服务页面查询您使用线上贷款服务平台的相关信息记录。为敦促您偿还欠款和保障使用安全，支付宝可能将根据贷款人的指令(在本合同约定的必要范围内)对您的账户进行扣划、限制等操作(例如，若还款日您未主动归还欠款，贷款人将会通过支付宝扣划您支付宝账户中的资金)；</p>
<p>2.您应妥善保管您的支付宝账户名、密码、数字证书、与支付宝账户绑定的手机动态校验码以及个人身份资料等重要信息；在线上贷款服务平台服务中，前述账户的操作行为均即视为您本人的行为，如开通服务、消费交易、查询记录、进行还款等，您将承担该等行为的相应法律后果。除使用密码等常用校验方式外，您亦认可贷款人可根据交易惯例及其他可验证您身份及意思表示的方式，确认您使用线上贷款服务平台服务的意愿，您不会仅以未使用密码等验证手段为由拒绝承认使用授信资金或还款。如您发现有他人冒用或盗用您的前述信息或其他未经您合法授权之情形时，请立即通过本合同所示联系方式通知客服。同时，请您知晓，对您的请求采取行动需要合理期限，在此之前若您遭受损失，除法律明确规定或贷款人存在过错外，合理期间内产生的损失，将由您自行承担；</p>
<p>3.您确认，您有足够的偿债能力，可以合理安排您的还款计划，按照本合同约定还款；除非各方达成一致，您不会要求优先向某一个或某几个贷款人还款。在您未清偿所有应还款项前，您对名下支付宝账户的变更或注销权利可能受到限制，您同意支付宝公司根据贷款人的指令执行前述限制措施；</p>
<p>4.贷款人可对您的还款资金来源进行监控与管理。您应保证还款账户余额充足且可被扣收，并按本合同的约定归还贷款本息及其他有关费用。逾期未清偿，将影响您的信用记录；</p>
<p>5.您应根据要求配合贷后管理需要及时提供贷款资金使用记录和资料。您承诺严格按本合同约定的用途使用贷款，不挤占挪用贷款，不将贷款用于购买住房、从事股本权益性投资、股票、基金、期货、金融衍生品投资或从事其他违法违规交易；</p>
<p>6.您的基本信息，如通讯地址、电子邮件地址、手机号码等发生变更的、或您的经济状况、还款能力出现不利变化，应及时通过400-868-9966联系客服；</p>
<p>7.请您知晓，您在本合同项下的各项授权或约定在本合同终止前持续有效。线上贷款服务平台服务所涉系统时间均以北京时间计；</p>
<p>8.需要提醒您注意的是，为避免您承担不必要的还款义务或其他责任，若您被欺诈或您的支付宝账户被盗期间，前述支付宝账户名下产生了因本贷款服务涉及的欠款，您同意并授权支付宝将您因此可能获得的补偿/赔付资金直接或从您的相关账户中扣划至贷款人账户用于清偿相应欠款；</p>
<p><strong>二、贷款人的主要权利和义务</strong></p>
<p>1.贷款人应按照本合同的约定发放贷款，行使相应的权利义务；</p>
<p>2.贷款人可按约向您主张贷款本息及费用，并请您就相关监督和检查工作提供方便；</p>
<p>3.若您发生本合同项下的违约行为或违反本合同其他约定，贷款人可通知支付宝公司对您的支付宝账户采取限制措施，或者采取本合同约定或法律允许的其他救济措施；</p>
<p>4.为确保您的贷款体验，根据业务需要贷款人可能需委托其他第三方对本贷款业务提供技术支持。</p>
<p><strong>第八条信息收集、使用、共享与保护</strong></p>
<p><strong>一、信息收集</strong></p>
<p>贷款人将根据合法、正当、必要原则，收集向您提供服务所需要的信息。您同意贷款人按照如下方式收集您的相关信息：</p>
<p>1.为了遵守法律法规对客户身份识别以及反洗钱等监管要求，并为了您正常、完整使用线上贷款服务平台服务，<strong>贷款人会收集您使用线上贷款服务平台服务时提供的或使用服务中产生的，或从关联公司和合作机构收集您的身份信息(包括身份证影印件)、联系方式(如电话、地址)、支付宝账户信息、身份验证信息、借还款银行账户信息等，</strong>最终收集信息内容以实际为准；</p>
<strong><p>2.为了客观、准确地评估您的还款能力、还款意愿和授信额度等，以及出于反套现、反欺诈等风险控制目的，防范可能的风险，我们将会：</p>
<p>2.1向中国人民银行金融信用信息基础数据库(以下简称“金融信用信息基础数据库”)采集您的信用报告；向法律、监管机构许可设立的信用服务机构采集与您信用相关的信息；</p>
<p>2.2向部分政府机构、司法机关、公共事业单位、行业组织、贷款人的关联公司以及合法留存您信息的其他方(如合作机构、合作商户、信息服务机构)等采集与线上贷款服务平台服务相关的必要信息，如身份信息、诉讼信息、交易信息、资产负债信息、履约信息及履约能力判断信息等；</p>
<p>2.3向您同意的其他来源收集与线上贷款服务平台服务相关的必要信息。</p>
<p>3.为了取得与您的联系、降低您的违约成本，贷款人需要收集您向贷款人及贷款人的关联公司或合作机构留存的其他联系方式等必要信息，如您留存的信息为您的关联人(包括亲戚朋友等)信息的，请您事先向关联人进行必要的告知(如信息范围、用途等)，并获得其同意。</p></strong>
<p>二、信息使用</p>
<p>为完整地向您提供服务以及保护各方的合法权益，请您理解和同意贷款人可能会将您的信息用于如下用途：</p>
<p><strong>1.为保护您交易及账户安全，校验信息的准确性，</strong>对您的身份及其他必要信息与政府机关、事业单位、商业机构等进行识别、验证等；</p>
<p><strong>2.为提供适合您的线上贷款服务平台服务，提供服务状态通知及查询服务，并持续维护、改善这些服务，</strong>对您的信息进行分析、加工和处理；</p>
<strong><p>3.为合理评估您的还款能力和还款意愿，防控风险；</p>
<p>4.预防或阻止违法、违规的活动，如识别、打击洗钱等；</p>
<p>5.为了维护您或贷款人的权益，或者为了解决贷款人与您之间就线上贷款服务平台服务产生的争议；</p>
<p>6.当您逾期欠款或存在无法自行按时还款的情形，请您理解和同意，在无法通过指定支付宝账户对应的手机号与您取得联络时，贷款人可通过您向贷款人及贷款人的关联公司或合作机构留存的其他联系方式联络您，如您的关联人接听了电话，贷款人可能会在关联人自愿的前提下请关联人向您转达相关信息，提示您及时履约；若您的关联人主动联系贷款人，愿意为您代为还款的，则将向您的关联人告知您的借款情况，以便其为您还款；</p></strong>
<p>7.根据法律法规、监管部门要求或其他经您另行明确同意的用途。</p>
<p><strong>三、信息共享</strong></p>
<p>贷款人承诺会根据法律法规及监管规定严格保护您的个人信息，不会为满足与线上贷款服务平台服务无关的第三方的营销目的而向其披露您的信息，您同意贷款人可能会在下列情况下将必要的信息与第三方共享：</p>
<p>1.若贷款人需要通过自身关联公司或合作方为您提供金融服务、客户服务、辅助核身服务或评估您的履约能力的(如与关联公司或合作方共同核验您的身份，评估您的授信风险、进行授信业务管理、通过前述主体展示您的可用额度或通过前述主体为您提供客户咨询、与线上贷款服务平台相关的周边服务等)您同意贷款人将您的必要信息(如身份信息、联系信息、履约信息和履约能力判断信息等)共享至前述主体，贷款人将要求前述主体对您的信息进行相应的保护；</p>
<p>2.为了促进社会信用体系的建立及完善，如实反馈您在使用线上贷款服务平台服务时的记录，您同意将您提供的或履约中产生的相关必要信息(包括不良信息)提供给中国人民银行金融信用信息基础数据库(以下简称“金融信用信息基础数据库”)、信用服务机构、中国互联网金融协会等行业自律组织或其他合法有权机构；</p>
<p>3.某些情况下，只有共享您的信息，才能处理与您相关的争议，维护您和/或贷款人的合法权益的，例如处理投诉、诉讼、投保及理赔等；</p>
<p>4.为了更好地为您提供服务，便于您及时了解使用线上贷款服务平台服务情况，您同意贷款人可通过贷款平台相关页面及信息渠道向您展示服务信息以及发送提醒通知；</p>
<p>5.若贷款人的关联公司或合作方根据其与您的约定可以获取您的履约情况等信息，贷款人将依据您同意的范围向关联公司或合作方提供该等信息；</p>
<p>6.为了满足贷款人审计需要，您同意在必要的前提下，向贷款人的审计机构或审计监管机构提供审计所需的必要信息；</p>
<p>7.因监管检查、行政和司法机关根据法律及行政法规的合法要求等。</p>
<p><strong>四、委托处理</strong></p>
<p>为了提升服务效率，降低服务成本，或提高服务质量，贷款人可能需要委托关联公司或合作机构(以下合称“受托机构”)协助完成本合同项下的部分服务或职责，例如：</p>
<p>1.委托受托机构按照本合同的约定采集您的信息或对您的信息进行分析、加工和处理，用于线上贷款服务平台服务的风险控制或维护、改善线上贷款服务平台服务；</p>
<p>2.委托受托机构提供客户服务(如调研，问询等)；</p>
<p>3.当您逾期欠款或发生其他违约行为时，贷款人可委托合作机构、律师事务所等合法合规的机构代为催收。为此，贷款人将在与线上贷款服务平台服务相关的必要范围内向受托机构提供您的部分信息。贷款人承诺受托机构同样遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您同意的用途，贷款人对您的信息安全承担相应的责任。</p>
<p><strong>五、信息保护</strong></p>
<p>除根据法律法规规定及本合同对您的个人信息和隐私予以保护外；在收集、使用、共享您的信息时，各贷款人将按照其发布的隐私权政策以及适用的其他隐私权政策或条款(如有)的要求严格保护您的信息，贷款人的合作机构亦将根据与您之间的相关隐私保护约定(包括：线上贷款服务平台隐私政策、贷款人及相关合作方通过公开渠道所发布的隐私保护类文本)严格保护您的信息。请您仔细阅读相关政策、条款，如有疑问，请随时联系我们或线上贷款服务平台客服服务。</p>
<p><strong>第九条违约及其违约处理</strong></p>
<p><strong>一、违约情形请您知晓，发生下列情况的，您将构成违约：</strong></p>
<p>1.您未按本合同约定按时足额偿还应还款额的；</p>
<p>2.您未按本合同约定用途使用贷款；</p>
<p>3.您违法违规使用贷款，如洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、其他监管机构、司法机构、贷款人认为不得使用线上贷款服务平台贷款进行的交易等；</p>
<p>4.您向贷款人或商户提供虚假的信息、资料或作出虚假承诺或您拒绝向贷款人提供其监督检查所需的必要材料，或通过其他违法违规方式获得授信额度及使用许可；</p>
<p>5.您被发现为逃避债务而转移资产，或存在其他未履行的到期债务，可能影响您的偿债能力的；</p>
<p>6.您在贷款人处的账户、您的支付宝账户或其他账户被司法机关冻结、划扣或账户被限权或止付等可能对您履行本合同项下还款义务产生不利影响的；</p>
<p>7.您违反贷款人的关联公司与您之间的约定、违反与其他贷款人之间的约定、您对其他第三方所负债务或违约责任可能影响您履行本合同项下义务或您可能发生其他违法违规或违反本合同任一条款约定的情形。</p>
<p><strong>二、违约救济措施</strong></p>
<p>若您出现前述违约情形的，贷款人将采取如下措施：</p>
<p>1.要求您限期纠正违约行为；</p>
<p>2.停止向您发放贷款，限制您参与线上贷款服务平台相关活动或权益获取；</p>
<p>3.宣布您未偿还的应付款项部分或全部提前到期，并要求您立即清偿；</p>
<p>4.根据本合同约定的途径和方式，持续对您进行扣款操作直至清偿全部应付款项；</p>
<p>5.处分抵押/质押财产或连带还款责任人(如有)履行还款义务，实现贷款人的债权；</p>
<p>6.指令支付宝对您本人的一个或几个支付宝账户进行限权，如对您支付宝账户中的部分或全部资金进行止付、限制向您提供支付宝账户支付、提现、转账等服务，您同意授权支付宝根据贷款人的前述指令进行相关操作；</p>
<p>7.扣划您在贷款人及贷款人关联公司或合作方处的应收或留存款项(如有)用以偿还您在贷款人处的应付款项；</p>
<p>8.以合法手段追偿您的应付款项(如委托合适的专业公司律师事务所等合法合规的机构代为催收，通过法院主张权利等)，由此引起的费用(如公证费、诉讼费、财产保全费、执行费、仲裁费、律师代理费、差旅费、评估费、拍卖费、催收费用等)由您承担；</p>
<p>9.通知贷款人关联公司，由关联公司依据其与您的相关约定判断是否采取进一步进行风险防范或挽回损失的措施；</p>
<p>10.贷款人根据法律法规或本合同约定可以采取的其他违约救济措施。</p>
<p>三、请您理解，除违约情形外，若您下落不明、失踪或死亡，处于限制民事行为能力或丧失民事行为能力状态，被行政或刑事处罚，或发生重大疾病、重大事故，卷入或可能卷入法律纠纷，您的资信情况、还贷能力出现其他重大不利变化(如收入降低、失业等)可能无法偿还贷款的，贷款人根据法律法规或本合同约定可能会要求您提前还款并根据实际需要采取相应违约救济措施。</p>
<p><strong>第十条 特别约定</strong></p>
<p>1.请您理解并同意，因下列原因导致贷款人无法正常提供服务的，贷款人不承担相应责任，但会尽合理努力积极促使服务恢复正常：</p>
<p>1)与贷款相关的系统停机维护或升级期间；</p>
<p>2)因台风、地震、洪水、雷电、群体性疾病或恐怖袭击等不可抗力原因；</p>
<p>3)您使用的电脑软硬件和通信线路、供电线路出现故障的；</p>
<p>4)您操作不当或通过非贷款人授权或认可的方式申请或使用本贷款的；</p>
<p>5)因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。</p>
<p>2.本合同有效期内，因国家相关主管部门颁布、变更的法律、法规、规章、规定、指引、通知、政策及其他规范性文件等导致贷款人不能继续为您服务的，该等情况将不视为违约，贷款人可根据相关规定变更合同内容或提前终止本合同，但会尽合理努力保障您的合法权益；</p>
<p>3.请您理解本合同所涉服务有赖于贷款平台或其他相关机构系统的准确运行及操作。若出现贷款平台系统差错、故障或其他原因引发了展示错误、您或贷款人不当获利等情形的，您同意贷款人可以自行或通过第三方采取更正差错、扣划款项、暂停服务等适当纠正措施；</p>
<p><strong>第十一条 合同的适用法律及争议解决方式</strong></p>
<p>本合同适用中华人民共和国法律(仅为本合同之目的，为避免疑义，不包括香港特别行政区、澳门特别行政区及台湾地区法律)。</p>
<p><strong>本合同在履行过程中发生争议，可以协商解决；协商不成的，双方均同意提交中卫仲裁委员会进行仲裁。双方同意中卫仲裁委员会可采取书面形式审理。仲裁遵循一裁终局的规则，裁决书对合同双方均有约束力。败诉方应承担对方为解决本争议而产生的所有费用，包括但不限于仲裁费、仲裁服务费、律师费、鉴定费、公证费、交通费等相关费用。</strong></p>
<p><strong>第十二条 合同的变更、终止和权利义务的转让</strong></p>
<p><strong>一、合同变更</strong></p>
<p>为了不断改进服务质量，贷款人将在不违反法律法规的前提下适时优化或修改本合同条款，但相关修改不会恶意加重您的责任或限制您的权利。一旦合同条款变更，贷款人将按本合同约定的通知方式通知您；除法律法规或监管规定另有强制性规定外，经修订的内容生效时间以通知载明日期为准。若您无法同意修改本合同，则请自该等通知送达之日起全额还清本合同项下的所有欠款并立即停止使用线上贷款服务平台服务；若您在修订生效后继续使用线上贷款服务平台服务，视为您接受修改后的合同内容。尽管有前述约定，您亦可通过与贷款人协商一致的方式进行合同变更。需要特别提醒您的是：本合同签署或变更后将取代贷款人与您就线上贷款服务平台服务事项于先前达成的合同或约定(如有)。</p>
<p><strong>二、合同终止</strong></p>
<p>除贷款人许可之外，在未结清本合同项下欠款及尚存待确定事项前，您无法终止本合同；如果有下列情形发生，贷款人可能会终止为您提供相关贷款服务同时要求您立即清偿所有贷款本息及相应费用：</p>
<p>1.您主动关闭贷款服务；</p>
<p>2.您在贷款服务中使用的支付宝账户被注销；</p>
<p>3.从事可能侵害本贷款服务系统、资料之行为；</p>
<p>4.支付宝公司部分或全部终止为您提供服务；</p>
<p>5.本合同约定的其他情形。</p>
<p><strong>三、合同权利义务的转让</strong></p>
<p>为保护您的合法权益，避免额外负债或影响信用，在贷款人书面同意前，您无法将本合同项下的权利和义务转让给第三方。基于业务实际，不对您使用线上贷款服务平台服务造成不利影响的前提下，贷款人可将其在本合同项下的权利和义务部分或全部转让给第三方。合同权利义务转让后，您同意与债权受让人之间基于本合同权利义务转让发生的争议适用本合同法律适用和争议条款的约定。</p>
<p><strong>第十三条 通知及仲裁文书的送达</strong></p>
<p><strong>一、通知</strong></p>
<p>除法律法规另有强制性规定外，本合同履行过程中，<strong>贷款人、司法机关或仲裁机构可以通过包括但不限于在线上贷款服务平台服务或贷款人网络页面公告或信息推送、向您发送电子邮件、手机短信和传真等电子方式进行书面通知，</strong>在采用电子方式进行书面通知的情况下发送当日即视为送达；采用邮寄方式传递给您的书面通知，按照您提供的通讯地址交邮后的第三个自然日即视为送达。贷款人可决定以前述一种或几种形式书面通知您。贷款人以多种方式向您发送通知的，通知送达时间以最先送达的为准。</p>
<p><strong>二、仲裁文书的送达</strong></p>
<p>您同意仲裁机构按照本合同附件《仲裁送达地址确认书》的约定向您送达仲裁文书。</p>
<p><strong>第十四条 术语定义</strong></p>
<p>1.线上贷款服务平台或线上贷款服务平台服务：指以<strong>“臻有钱”</strong>作为运营品牌，由具有专业资质的各类金融机构作为授信机构，提供的在线消费金融服务。由授信机构向您提供个人消费信贷服务。线上贷款服务平台的营销名称可能因业务需要而被调整；</p>
<p>2.授信额度：指授信机构基于对您的风险评估而授予您的信用额度，您可在该额度范围内使用授信机构提供的授信资金。您的授信额度可能因授信机构的更替而产生变化；</p>
<p>3.指定支付宝账户：指您申请、签约、使用、终止线上贷款服务平台服务所必需的您本人的支付宝账户；</p>
<p>4.指令：系指令方按照业务设定的流程及规则，输入密码或按照约定的方式自行或通过第三方向授信机构、支付宝以及其他相关方发出的各项指示(如信息传递指令、支付指令、授权性指令等)，在没有与您另有约定的情况下，所有指令及其内容发出后均无法撤销及变更。指令发送将基于您的授权(明示或者默示)或指令方认为系业务所需，如超出前述范围发送指令，指令方将承担相应的责任；</p>
<p>5.应还款额：指您累计已逾期和在当月还款日应当偿还的本金、相应息费等金额总和；</p>
<p>6.应付款项：指您尚未偿还的所有本金、累计已产生且未偿还的利息、逾期利息及其他因线上贷款服务平台服务产生或与线上贷款服务平台服务有关的款项，如套现违约金、授信机构为您垫付的费用及实现债权的费用，如催收费、诉讼费、律师代理费、公证费、交通费、鉴定费等；</p>
<p>7.还款日：指每月的还款日期，具体以线上贷款服务平台服务页面显示为准，您应在该日前(含)归还应还款额；</p>
<p>8.支付宝：指支付宝(中国)网络技术有限公司；</p>
<p>9.“线上贷款服务平台服务页面”，指由线上贷款服务平台服务顾问或其合作方运营的网站、移动客户端、WAP页面等组成的线上贷款服务平台网络服务入口和功能、展示页面(以实际开放的为准)。</p>
<p><strong>附件一：仲裁文书送达地址确认书</strong></p>
<p>1．本人同意与贷款人在线订正贷款合同(以下简称“合同”)对于因合同争议引起的任何纠纷，本人声明仲裁机构可以手机短信等现代通讯方式或邮寄方式向本人送达仲裁文书；</p>
<p>2.本人指定接收仲裁文书的手机号码为签约账户绑定的手机号码{mobile}，仲裁机构以前述码址发出仲裁文书即视为送达；</p>
<p>3.本人指定邮寄地址为本人身份证住址；</p>
<p>4.本人同意仲裁机构可采取以上一种或多种送达方式向本人送达仲裁文书，仲裁机构采取多种方式向本人送达仲裁文书，送达时间以上述送达方式中最先送达的为准；</p>
<p>5.本人确认的上述送达方式适用于各个仲裁阶段、司法阶段，如仲裁、执行以及督促程序(含支付令送达)等；</p>
<p>6.若本人上述送达地址有变更，本人应当及时告知贷款人和仲裁机构、司法机关(如适用)变更后的送达地址；</p>
<p>7.督促程序中，若本人任意提出异议进而使纠纷进入仲裁程序，在仲裁委最终裁决本人承担责任的情况下，因此产生的所有费用(如律师费、支付令申请费和仲裁费等)，均由本人承担；</p>
<p>8.本人已阅读本确认书所有条款，并保证上述送达地址是准确、有效的；如果提供的送达地址不确切，或不及时告知变更后的地址，使仲裁文书无法送达或未及时送达，本人自行承担由此可能产生的法律后果。</p>

<p>借款人：{userName}</p>
<p>日期：{effectiveDate}</p>
<p>电子签名：</p>


<p>贷款人：杭银消费金融股份有限公司</p>
<p>日期：{effectiveDate}</p>
<p>电子签名：</p>
      </div>
      </div>
    );
  }
}
